import React, { useState } from "react";
import { wrapTextToWidth } from "utils/shortTermGoals";

const RoadmapDisplayTitle = ({ key, phaseTitle, width, position }) => {

  console.log('sss RoadmapDisplayTitle', phaseTitle, width, position)

  return (
    <>
      <div 
        class="phaseTitleHover "
        key={key} 
        title={phaseTitle}
        style={{ 
          // width: width,
          position: 'fixed',
          width: "max-content",
          zIndex: "10",
          bottom: "165px",
          left: position.x + 15,
          top: position.y - 85,
          padding: "15px 8px",
          alignItems: "center",
          // top: position.x - position.bottom,
          // // right: position.right,
          // bottom: `${position.y - 115}px`,
          // left: position.left - position.y,
        }}
      >
        {
          phaseTitle
        }
        {
          // wrapTextToWidth(phaseTitle, 200, '15px AvenirBook').map(item => {
          //   return <p>
          //     {item}
          //   </p>  
          // })
        }
      </div>   
    </>
  )
}

export default RoadmapDisplayTitle